import React from "react";
import PropTypes from "prop-types";
import { Link, Modal, TextInput } from "@sia/style-guide";
import useMasterKeyModal from "./useMasterKeyModal";
import "./MasterKeyModal.scss";

const MasterKeyModal = ({ translate }) => {
  const {
    isMasterKeyModalShown,
    masterKeyMode,
    key,
    oldKey,
    invalidText,
    invalidTextOldKey,
    setKey,
    setOldKey,
    changeMode,
    submit,
    close,
  } = useMasterKeyModal(translate);

  if (!isMasterKeyModalShown) return null;
  const confirming = masterKeyMode === "confirm-new-key";
  const changing = masterKeyMode === "change-key";
  const entering = masterKeyMode === "enter-key";
  const confirmLabel = translate(`benchmarking.master-key-modal.primary-button.${masterKeyMode === "create-key" || confirming ? masterKeyMode : "submit"}`);

  return (
    <div className="master-key-modal">
      <Modal
        title={translate(`benchmarking.master-key-modal.title.${masterKeyMode}`)}
        lead={translate(`benchmarking.master-key-modal.lead.${masterKeyMode}`)}
        formElement={
          <form onSubmit={(event) => { event.preventDefault(); void submit(); }}>
            {confirming ? (
              <><strong>{translate("benchmarking.master-key-modal.blurb.confirm-new-key")} {key}<br /></strong><br />{translate("benchmarking.master-key-modal.sublead.confirm-new-key")}</>
            ) : (
              <>
                {changing && <TextInput id="old-master-key-input" onChange={(event) => setOldKey(event.target.value)} value={oldKey} autoFocus invalidText={invalidTextOldKey} password label={translate("benchmarking.master-key-modal.old-key")} />}
                <TextInput id="master-key-input" onChange={(event) => setKey(event.target.value)} value={key} autoFocus={!changing} invalidText={invalidText} password label={entering ? "" : translate("benchmarking.master-key-modal.new-key")} />
                {entering && (
                  <>
                    <div className="sia-padding-03-bottom"><Link withLeadIcon type="internal" target={() => changeMode("change-key")}>{translate("benchmarking.survey.master-key.change.link")}</Link></div>
                    <Link withLeadIcon type="internal" target={() => changeMode("reset-key")}>{translate("benchmarking.wrong-master-key-page.reset.link")}</Link>
                  </>
                )}
              </>
            )}
            <button type="submit" hidden tabIndex={-1}>{confirmLabel}</button>
          </form>
        }
        confirmLabel={confirmLabel}
        onConfirm={submit}
        cancelLabel={translate("benchmarking.master-key-modal.secondary-button.cancel")}
        onCancel={() => close(false)}
      />
    </div>
  );
};

MasterKeyModal.propTypes = { translate: PropTypes.func.isRequired };
export default MasterKeyModal;
